import { combineReducers, AnyAction } from '@reduxjs/toolkit';

import { reducer as ModalReducer } from './modal';
import { reducer as NavigationReducer } from './navigation';
import { reducer as UtmReducer } from './utm';

import { GlobalActionTypes } from '@/types';

const appReducer = combineReducers({
  modal: ModalReducer,
  navigation: NavigationReducer,
  utm: UtmReducer,
});

// eslint-disable-next-line
const rootReducer = (
  state: ReturnType<typeof appReducer>,
  action: AnyAction,
) => {
  if (action.type === GlobalActionTypes.ClearStore) {
    return appReducer(undefined, ({ type: undefined } as never));
  }
  return appReducer(state, (action as never));
};

export default rootReducer;
